import {
  ADD_NEW_MACHINE_FAIL,
  ADD_NEW_MACHINE_REQUEST,
  ADD_NEW_MACHINE_SUCCESS
} from './action';
import * as mutations from './mutations';

export function addNewMachine(payload) {
  const { materialNumber, serialNumber, claimingCode } = payload;
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: ADD_NEW_MACHINE_REQUEST });
      const clientResponse = await client.mutate({
        mutation: mutations.claimMachine,
        variables: {
          input: {
            materialNumber,
            serialNumber,
            claimingCode
          }
        }
      });
      const result = clientResponse?.data?.claimMachine;
      setTimeout(() => {
        dispatch({
          type: ADD_NEW_MACHINE_SUCCESS,
          payload: { newMachine: result }
        });
      }, 500);
    } catch (error) {
      dispatch({ type: ADD_NEW_MACHINE_FAIL, payload: { error } });
    }
  };
}
